import { render } from "./TransactionListRecent.vue?vue&type=template&id=0e42f5ec&scoped=true&ts=true"
import script from "./TransactionListRecent.vue?vue&type=script&lang=ts"
export * from "./TransactionListRecent.vue?vue&type=script&lang=ts"

import "./TransactionListRecent.vue?vue&type=style&index=0&id=0e42f5ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e42f5ec"]])

export default __exports__